import React from "react";
import './customswservices.css';
import PageTemplate from "../../templates/page-template/PageTemplate";
import CustomSWContent from "../../organisms/CustomSWContent/CustomSWContent";

const CustomSWServices: React.FC = () => {
    return (
        <PageTemplate children={<CustomSWContent/>}></PageTemplate>
    );
};

export default CustomSWServices;